import Model from "../../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const DeleteKitchen = ({
    setIsDeleteKitchen,
    selectedData,
    deleteKitchenLoading,
    deleteKitchenMutate,
}) => {
    const handleDeleteSubmit = () => {
        deleteKitchenMutate({
            kitchenId: selectedData?.id,
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteKitchen}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this kitchen?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteKitchen(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteKitchenLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteKitchenLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteKitchen;